"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styles_1 = require("@mui/material/styles");
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const react_router_dom_1 = require("react-router-dom");
const Box_1 = __importDefault(require("@mui/material/Box"));
const KeyboardArrowIcon_1 = __importDefault(require("./KeyboardArrowIcon"));
const themes_1 = require("../../../themes");
const StyledButton = (0, styles_1.styled)(Button_1.default)(({ theme }) => ({
    color: theme.palette.grey[900],
    fontSize: 14,
    textTransform: 'none',
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    paddingTop: 0,
    paddingBottom: 0,
}));
const BottomBarMenuItem = ({ index, label, url, externalUrl, subLinks, onClick, }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const theme = (0, styles_1.useTheme)();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledButton, Object.assign({ id: `basic-button-${index}`, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: (e) => {
                if (onClick)
                    onClick(e);
                handleClick(e);
            } }, {
            href: externalUrl ? url : undefined,
            to: !externalUrl ? url : undefined,
            component: externalUrl || subLinks ? 'a' : react_router_dom_1.Link,
        }, { theme: theme, disableTouchRipple: true, disableFocusRipple: true, sx: {
                marginRight: themes_1.Spacings.small3,
                fontFamily: 'Avenir LT W01_85 Heavy1475544',
                letterSpacing: 0,
                justifyContent: 'center',
            } }),
            React.createElement(Box_1.default, { component: "span", sx: {
                    display: 'flex',
                    lineHeight: 1.5,
                    overflow: 'auto',
                    '&>img': { paddingLeft: themes_1.Spacings.small },
                } },
                React.createElement("span", null, label),
                ' ',
                (subLinks === null || subLinks === void 0 ? void 0 : subLinks.length) && React.createElement(KeyboardArrowIcon_1.default, { isOpen: !!anchorEl }))),
        (subLinks === null || subLinks === void 0 ? void 0 : subLinks.length) && (React.createElement(Menu_1.default, { anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                'aria-labelledby': 'basic-button',
            }, sx: {
                '& .bottom-bar-menu': {
                    borderRadius: 0,
                    minWidth: '176px',
                    boxShadow: `0px 5px 5px -3px #e4e5ea, 0px 8px 10px 1px #e4e5ea, 0px 3px 14px 2px #e4e5ea`,
                },
            }, classes: {
                paper: 'bottom-bar-menu',
            } }, subLinks.map((link) => (React.createElement(MenuItem_1.default, Object.assign({ key: link.label }, {
            href: link.externalUrl ? link.url : undefined,
            to: !link.externalUrl ? link.url : undefined,
            component: link.externalUrl ? 'a' : react_router_dom_1.Link,
        }, { onClick: (e) => {
                if (link.onClick)
                    link.onClick(e);
                handleClose();
            }, disableTouchRipple: true, sx: {
                fontSize: 14,
                letterSpacing: 0,
                paddingY: themes_1.Spacings.small2,
                paddingX: themes_1.Spacings.small3,
                '&:active.MuiMenuItem-root': {
                    backgroundColor: theme.palette.grey[400],
                },
                '&:hover': {
                    backgroundColor: theme.palette.grey[300],
                },
            } }), link.label)))))));
};
exports.default = BottomBarMenuItem;
